<template>
	<div class="main-product marco zoom" oncontextmenu="return false">
		<img class="img-responsive main-image center-block" :src="render_main_image || image" alt="producto">
	</div>
	<div class="row">
		<div class="col-xs-3 col-sm-4 col-md-3" v-for="image in render_images.images" @click="changeImage($index, $event)">
			<div class="main-product-views image-for-zoom">
				<img oncontextmenu="return false" :src="image.route || image" alt="producto" class="img-responsive">
			</div>
		</div>
	</div>
</template>

<style scoped>
	.row:nth-of-type(1){
		padding-top: 5px;
	}
</style>

<script>
import image from '../../images/default.jpg';
import { api_base } from '../../store/api';

export default {
	data() {
		return {
			image: image,
			api_base
		};
	},

	vuex: {
		getters: {
			product: state => state.current_product
		}
	},

	methods: {
		changeImage(index, e) {
			$('.main-image').trigger('zoom.destroy');
			let src = this.product.images[index].route;
      $('.main-image').attr('src', src);
      // [TODO]: zoom does not works anymore, check why.
			// $('.main-image')
			// 	.css('display', 'block')
			// 	.parent()
			// 	.zoom({
			// 		magnify: 0.8
      //   });

			$('.image-for-zoom').removeClass('active-zoom');
			$(e.target).parent().addClass('active-zoom');
		}
	},

	computed: {
		render_images() {
			return this.product;
		},

		render_main_image() {
			if (this.product.images && this.product.images.length) {
				setTimeout(() => {
					$('.main-image')
						.css('display', 'block')
						.parent()
						.zoom({
							magnify: 0.8
						});
				}, 50);

				if ($('.image-for-zoom').length)
					$('.image-for-zoom')[0].classList.add('active-zoom');

				return this.product.images[0].route;
			}
		}
	},
}
</script>



// WEBPACK FOOTER //
// Product-detail-images.vue?b1c1f40a